/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const BitcoinLightning: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M13.7572 9.96964L15.7315 2.63738C15.8662 2.1368 15.2282 1.78541 14.8484 2.15108L4.31092 12.2973C3.64673 12.9369 4.11713 14.0304 5.05644 14.0304H10.2428L8.26854 21.3626C8.13375 21.8632 8.77182 22.2146 9.15159 21.8489L19.6891 11.7027C20.3533 11.0631 19.8829 9.96964 18.9436 9.96964H13.7572Z'
      fill='currentColor'
    />
  </React.Fragment>
)
